<template>
  <div class="guide">
    <div v-if="currentId==0">
      <p class="title title_01">智伴优学VIP课程包是什么？有什么用？</p>
      <div class="guide-list" v-for="guide in guideList" :key="guide.id">
        <div class="age">{{guide.title}}</div>
        <p :class="guide.text|textClass" v-for="item in guide.text" :key="item.index">{{item}}</p>
      </div>
    </div>
    <div v-show="currentId==1">
      <p class="title title_02">如何购买智伴优学VIP课程包？</p>
      <div class="item">
        <img class="item-text" src="/images/guideline/guide02_text.png" alt="">
        <img class="guide-img" src="/images/guideline/guide02_01.png" alt="">
        <img class="guide-img" src="/images/guideline/guide02_02.png" alt="">
        <img class="guide-img" src="/images/guideline/guide02_03.png" alt="">
        <img class="guide-img" src="/images/guideline/guide02_04.png" alt="">
      </div>
    </div>
    <div v-show="currentId==2">
      <p class="title title_03">如何使用智伴优学VIP课程包？</p>
      <div class="item">
        <img class="item-text" src="/images/guideline/guide03_text.png" alt="">
        <img class="guide-img" src="/images/guideline/guide03_01.png" alt="">
        <img class="guide-img" src="/images/guideline/guide03_02.png" alt="">
        <img class="guide-img" src="/images/guideline/guide03_03.png" alt="">
        <img class="guide-img" src="/images/guideline/guide03_04.png" alt="">
        <img class="guide-img" src="/images/guideline/guide03_05.png" alt="">
        <img class="guide-img" src="/images/guideline/guide03_06.png" alt="">
      </div>
    </div>
    <div v-show="currentId==3">
      <p class="title title_04">如何邀请好友加入智伴优学VIP？</p>
      <div class="item">
        <img class="item-text" src="/images/guideline/guide04_text.png" alt="">
        <img class="guide-img" src="/images/guideline/guide04_01.png" alt="">
        <img class="guide-img" src="/images/guideline/guide04_02.png" alt="">
        <img class="guide-img" src="/images/guideline/guide04_03.png" alt="">
        <img class="guide-img" src="/images/guideline/guide04_04.png" alt="">
      </div>
    </div>
    <div v-show="currentId==4">
      <p class="title title_05">邀请好友加入智伴优学VIP可以获得什么奖励？</p>
      <div class="guide-list" v-for="guide in guideList" :key="guide.id">
        <div class="age age_05">{{guide.title}}</div>
        <p :class="guide.text|textClass" v-for="item in guide.text" :key="item.index">{{item}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { guideline_guide_get } from '@/api/staticApi.js';
import { isArray } from 'lodash';

export default {
  data() {
    return {
      currentId: this.$route.query.id,
      guideList: {}
    };
  },
  created() {
    if (this.currentId == 0 || this.currentId == 4) {
      this.loadData()
    }
  },
  methods: {
    loadData () {
      guideline_guide_get().then(res => {
        if (this.currentId == 0) {
          this.guideList = res.effect
        } else {
          this.guideList = res.reward
        }
      })
    }
  },
  filters: {
    textClass (params) {
      if (params.length>1){
        return 'text'
      } else {
        return 'effect'
      }
    }
  }
};
</script>

<style scoped>
.guide{
  padding: 8px 26px 41px 26px;
  background: #FCFBFB;
  min-height: 100vh;
}
.title{
  height: 83px;
  line-height:83px;
  position: relative;
  font-size:15px;
  color: #244352;
  margin-bottom: 10px;
}
.title::after{
  content: '';
  position: absolute;
  left: -75px;
  width: 79px;
  height: 83px;
}
.title_01::after{
  background: url('/images/guideline/title_bg_01.png') no-repeat;
  background-size: 79px 83px;
}
.title_05::after{
  background: url('/images/guideline/title_bg_05.png') no-repeat;
  background-size: 79px 83px;
}
.title_02::after{
  background: url('/images/guideline/title_bg_02.png') no-repeat;
  background-size: 79px 83px;
}
.title_03::after{
  background: url('/images/guideline/title_bg_03.png') no-repeat;
  background-size: 79px 83px;
}
.title_04::after{
  background: url('/images/guideline/title_bg_04.png') no-repeat;
  background-size: 79px 83px;
}
.guide-list{
  width:324px;
  height:117px;
  background: #fff;
  border-radius:16px;
  box-shadow:0px 4px 6px rgba(0,0,0,0.08);
  position: relative;
  padding: 37px 12px 31px 16px;
  font-size:14px;
  color: #6A92A4;
  margin-bottom: 33px;
}
.guide-list:nth-last-of-type(1){
  margin-bottom: 0;
}
.guide-list .age{
  width: 77px;
  height: 40px;
  position: absolute;
  left: 0;
  top: -7px;
  background: url('/images/guideline/age_bg.png') no-repeat;
  background-size: 77px 40px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 37px;
}
.age.age_05{
  background: url('/images/guideline/age_05.png') no-repeat;
  background-size: 77px 40px;
}
.guide-list .text{
  display: inline-block;
  width: 50%;
  height: 20px;
  line-height: 20px;
  padding-left: 17px;
  position: relative;
}
.guide-list .text:nth-child(1){
  margin-bottom: 9px;
}
.guide-list .text::before{
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  background: url('/images/guideline/list_icon.png') no-repeat;
  background-size: 100% 100%;
}
.guide-list .effect{
  line-height:24px;
}
.item{
  border-radius: 16px;
  box-shadow:0px 4px 6px rgba(0,0,0,0.08);
  position: relative;
}
.item-text{
  display: block;
  width: 105px;
  height: 44px;
  position: absolute;
  left: 0;
  top: -10px;
}
.guide-img{
  display: block;
  width: 324px;
}
</style>
